// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2cxpf","label":"SetPasswdForm_label__10gLA"};